import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'ramda'
import { colors, fontWeights } from '@/styles'
import { StatusContainer } from '@/features/Application/elements'
import Empty from './empty'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 18px;
`

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid ${colors.grey88};
  padding: 12px 12px;
  font-weight: ${fontWeights.medium};
`

const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`

const Text = styled.p`
  font-weight: ${fontWeights.medium};
  font-size: 14px;
  line-height: 20px;
  color: ${colors.grey16};
  margin: 0;
  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
`

const StatusText = styled.span`
  font-weight: ${fontWeights.medium};
  font-size: 14px;
  line-height: 20px;
  color: ${colors.red40};
  margin: 0;
  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
`

const Mobile = ({ data = {}, isLocked, application, isLoading, standalone }) => {
  const { t } = useTranslation()
  const rate = data?.potential_risks?.rate
  const details = data?.potential_risks?.details ?? []
  const isActive =
    application?.trust_score?.status === 'active' ||
    (standalone && application?.status !== 'failed')
  const title = t('l.application.view.potential_risks.label', 'Potential Risks')
  const showStatus = true
  const status = {
    poor: t('l.application.view.poor.label', 'Poor'),
    average: t('l.application.view.average.label', 'Average'),
    very_good: t('l.application.view.very_good.label', 'Very Good'),
    excellent: t('l.application.view.excellent.label', 'Excellent')
  }

  const statusText = status[rate]

  return (
    <Wrapper>
      <StatusContainer
        title={title}
        showStatus={showStatus}
        statusType={rate}
        statusTitle={statusText}
        isLocked={isLocked}
        isLoading={isLoading}
      >
        <Container>
          <EmptyWrapper>
            {!isActive || isEmpty(details) ? (
              <Empty isLocked={isLocked} isActive={isActive} isLoading={isLoading} />
            ) : (
              <Text isLocked={isLocked}>
                <StatusText isLocked={isLocked}>{details}</StatusText>
              </Text>
            )}
          </EmptyWrapper>
        </Container>
      </StatusContainer>
    </Wrapper>
  )
}

export default Mobile
